/**
 * The Connect tab's words for the hosted page and the allowlist — Story 25.9.
 *
 * Kept apart by WHERE EACH WORD COMES FROM, as `publish-copy.ts` does, because
 * each kind is held to a different source by `tests/connect-copy.test.ts`:
 *
 *   DRAWN     `design/screens/editor-connect.html` draws it — the default,
 *             `hosted` and `no-website` captures (Story 25.1, block 5). Held to
 *             the mockup, verbatim.
 *   COMPOSED  no capture draws it: the Free plan's own note under the link, and
 *             the hosted link of a funnel that is not published yet. Built on
 *             the drawn sentences' shapes, and listed here so a round-trip
 *             replaces them in one place.
 *
 * NO RUNTIME IMPORTS, so a node-side test can load this file without resolving
 * the workspace.
 */

export const DRAWN = {
  /** Under the allowlist once the hosted page takes its own submissions (DECISION-160). */
  allowlistHelp: 'Your funnel accepts submissions from these websites, and from its own hosted page.',
  /** In its place when the list is empty — `no-website`. A fact, never the error colour. */
  noWebsite:
    "No website listed yet, so the funnel takes submissions only on its hosted page. Add your site's address here when you have one.",
  noWebsitePlaceholder: 'yourbusiness.com',
  /** The `hosted` state. */
  hostedLine:
    'Share this link. It opens the funnel on a page of its own, so people can fill it in without your website.',
  copyLink: 'Copy link',
  openPage: 'Open the page',
  /** Under the link on a paid plan, whose link is on the paid host. */
  hostedPaidNote: 'On the Free plan the link starts with leadgible.link instead — the address free funnels are served from.',
} as const

export const COMPOSED = {
  /** The same note on the Free plan, whose link already starts there. */
  hostedFreeNote: 'The link starts with leadgible.link — the address free funnels are served from.',
  /** The drawn "not published yet" line, for a link rather than a snippet. */
  hostedUnpublished: 'This funnel is not published yet, so the link above will not open anything until you publish it.',
} as const
